import { render, staticRenderFns } from "./TP5.vue?vue&type=template&id=72334c38"
import script from "./TP5.vue?vue&type=script&lang=js"
export * from "./TP5.vue?vue&type=script&lang=js"
import style0 from "./TP5.vue?vue&type=style&index=0&id=72334c38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports